module.exports = __webpack_public_path__ + "ce507cccfd7e1aa58a5b1586b8d12514.png";